module.exports = __webpack_public_path__ + "img/cake.a006d1d3.png";